import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface stateType {
  currentFormStep: number;
}

const initialState = {
  currentFormStep: 1,
} satisfies stateType as stateType;

const slice = createSlice({
  name: "compare",
  initialState,
  reducers: {
    setCurrentFormStep: (state, action: PayloadAction<number>) => {
      state.currentFormStep = action?.payload;
    },
  },
});

export const Actions = slice.actions;
export default slice.reducer;
